/**
 * Professional Smooth Corners Paint Worklet
 * 
 * Implements iOS-style "Squircels" (superellipses) using the n-exponent formula.
 * Provides much smoother corner transitions than standard border-radius.
 */

class SmoothCorners {
  static get inputProperties() {
    return [
      '--fluent-smooth-corners-radius',
      '--fluent-smooth-corners-fill',
      '--fluent-smooth-corners-exponent'
    ];
  }

  paint(ctx: CanvasRenderingContext2D, size: { width: number; height: number }, props: any) {
    const r = parseFloat(props.get('--fluent-smooth-corners-radius')) || 24;
    const fill = props.get('--fluent-smooth-corners-fill').toString() || 'currentColor';
    const n = parseFloat(props.get('--fluent-smooth-corners-exponent')) || 4; // 4 = typical squircel

    ctx.fillStyle = fill;
    ctx.beginPath();

    const halfW = size.width / 2;
    const halfH = size.height / 2;

    // Implementation of the Lamé curve equation: |x/a|^n + |y/b|^n = 1
    for (let i = 0; i <= size.width; i++) {
        const x = i - halfW;
        const val = Math.pow(Math.abs(halfW - r), n) - Math.pow(Math.abs(x), n);
        
        // This is a simplified approximation for real-time rendering
        if (val >= 0) {
            const y = Math.pow(val, 1 / n);
            if (i === 0) ctx.moveTo(i, halfH - y);
            else ctx.lineTo(i, halfH - y);
        }
    }

    for (let i = size.width; i >= 0; i--) {
        const x = i - halfW;
        const val = Math.pow(Math.abs(halfW - r), n) - Math.pow(Math.abs(x), n);
        if (val >= 0) {
            const y = Math.pow(val, 1 / n);
            ctx.lineTo(i, halfH + y);
        }
    }

    ctx.closePath();
    ctx.fill();
  }
}

registerPaint('fluent-smooth-corners', SmoothCorners);
